import React from 'react';
import { modes } from '@comall-backend-builder/types';
import { Numberbox } from '@comall-backend-builder/components-basis';

export class MarginRowNumberMode extends modes.NumberIntegerMode {
    /**
     * 获取输入组件
     */
    public getControlComponent(controlInfo: any): JSX.Element {
        const { maxConfig, minConfig, row } = controlInfo;
        if (maxConfig) {
            controlInfo.max = row[maxConfig];
        }
        if (minConfig) {
            controlInfo.min = row[minConfig];
        }
        return <Numberbox {...controlInfo} min={0} max={50} />;
    }
}
